import React from 'react';
import StatsOverview from './StatsOverview/StatsOverview.jsx';
import QuickActions from './QuickActions/QuickActions.jsx';
import CargoInsights from './CargoInsights/CargoInsights.jsx';
import './Dashboard.css';

const Dashboard = ({ cargos, cargoArea, selectedRows, onAction, activeTab }) => {
  return (
    <div className="dashboard-full-page">
      <div className="dashboard-content-full">
        {activeTab === 'overview' && (
          <StatsOverview 
            cargos={cargos}
            cargoArea={cargoArea}
            selectedRows={selectedRows}
          />
        )}
        
        {activeTab === 'actions' && (
          <QuickActions 
            cargos={cargos}
            selectedRows={selectedRows}
            onAction={onAction}
          />
        )}
        
        {activeTab === 'insights' && (
          <CargoInsights 
            cargos={cargos}
            cargoArea={cargoArea}
          />
        )}
      </div>
    </div>
  );
};

export default Dashboard;